export default {
    setCookie(cname, cvalue, exdays) {
        var d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        var expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/;samesite=strict";
    },
    
    getCookie(cname){
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for(var i = 0; i <ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' '){
                c = c.substring(1);
            }
     
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    },

    /**
     * Prevent multiple import of google maps
     * https://stackoverflow.com/questions/9719157/you-have-included-the-google-maps-api-multiple-times-on-this-page-this-may-caus
     */
    removeGoogleMapScript() {
        let keywords = ['maps.googleapis'];
    
        //Remove google from BOM (window object)
        window.google = undefined;
    
        //Remove google map scripts from DOM
        let scripts = document.head.getElementsByTagName("script");
        for (let i = scripts.length - 1; i >= 0; i--) {
            let scriptSource = scripts[i].getAttribute('src');
            if (scriptSource != null) {
                if (keywords.filter(item => scriptSource.includes(item)).length) {
                    scripts[i].remove();
                }
            }
        }
    }
}